import { RouteObject } from 'react-router-dom';
import Home from '../pages/home/page';
import Hosting from '../pages/hosting/page';
import Rentals from '../pages/rentals/page';
import DSCR from '../pages/dscr/page';
import NotFound from '../pages/NotFound';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/rentals',
    element: <Rentals />,
  },
  {
    path: '/dscr',
    element: <DSCR />,
  },
  {
    path: '/hosting',
    element: <Hosting />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
